import { useMemo } from "react";

import type { PackageCardProps } from "./package-card.types";

const DISPLAY_MAX_SUB_PRODUCTS_LIMIT = 2;
const DISPLAY_MAX_SUB_PRODUCTS_WORDS_LENGTH_LIMIT = 18;

interface UseSubproductsResult {
  subproducts: PackageCardProps["bloodTests"];
  restSubProducts: PackageCardProps["bloodTests"];
}

export const useSubproducts = (
  products: PackageCardProps["bloodTests"],
  maxLength: number = DISPLAY_MAX_SUB_PRODUCTS_WORDS_LENGTH_LIMIT,
): UseSubproductsResult =>
  useMemo(() => {
    // Sortowanie tablicy według długości ciągów
    const sortedProducts = products.toSorted((a, b) => a.length - b.length);

    const subproductsList: PackageCardProps["bloodTests"] = [];
    const restSubProductsList: PackageCardProps["bloodTests"] = [];

    for (const product of sortedProducts) {
      if (subproductsList.length < DISPLAY_MAX_SUB_PRODUCTS_LIMIT && product.length < maxLength) {
        subproductsList.push(product);
      } else {
        restSubProductsList.push(product);
      }
    }

    return { subproducts: subproductsList, restSubProducts: restSubProductsList };
  }, [products, maxLength]);
